<template>
	<NuxtLayout>
		<VitePwaManifest />
		<NuxtLoadingIndicator />
		<NuxtPage v-if="!isLoading" />
	</NuxtLayout>
</template>

<script setup lang="ts">
import { ref } from "vue";

const isLoading = ref(false);
const i18nHead = useLocaleHead({
	addDirAttribute: true,
	addSeoAttributes: true
});

useHead(i18nHead);
</script>
